<template> 
      <div  class="cusgl" :style="orvalue[orientation]"  >
         <svg width="100%" height="100%" viewBox="0 0 163 225"  preserveAspectRatio="xMinYMin  meet">    
              <g >
                <path style="fill: #1369d6;fill-rule: evenodd;" d="M0,225V0l163,1L10,12Z"/>
            </g>
        </svg>
      </div>
</template>
<script>
export default {
    name: 'cusar',
    inject:['root'],
  props: {  
    orientation: {
      type: String,
      default: "topLeft"
    },
  },
  data () {  
    return {     
       orvalue:{
         topLeft:"left: -1px;top: -1px;"+(this.root.device=='phone'?'width:30px;height:45px':''),
         topRight:"transform:rotateY(180deg);right: -1px;top: -1px;"+(this.root.device=='phone'?'width:30px;height:45px':''),
         bottomRight:"transform:rotate(180deg);bottom: -1px;right:-1px;"+(this.root.device=='phone'?'width:30px;height:45px':''),
         bottomLeft:"transform:rotateX(180deg);left: -1px;bottom: -1px;"+(this.root.device=='phone'?'width:30px;height:45px':''),
       },
      
    }
  },
  methods: {
     isMobile() {
      var userAgentInfo = navigator.userAgent;
      var mobileAgents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      var mobile_flag = false;
      //根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      // return false;// mobile_flag;
        return mobile_flag;
    }
  },
  mounted () {
 
  },
  
}
</script>

<style lang="scss">
.cusgl{
  width: 30px;
  height: 45px;
  position: absolute;
  z-index: 1;

}

</style>